__turbopack_context__.v({
  "button": "Button-module__cl0yeW__button",
  "button__danger": "Button-module__cl0yeW__button__danger",
  "button__filled": "Button-module__cl0yeW__button__filled",
  "button__fullWidth": "Button-module__cl0yeW__button__fullWidth",
  "button__ghost": "Button-module__cl0yeW__button__ghost",
  "button__lg": "Button-module__cl0yeW__button__lg",
  "button__loading": "Button-module__cl0yeW__button__loading",
  "button__md": "Button-module__cl0yeW__button__md",
  "button__outline": "Button-module__cl0yeW__button__outline",
  "button__primary": "Button-module__cl0yeW__button__primary",
  "button__secondary": "Button-module__cl0yeW__button__secondary",
  "button__sm": "Button-module__cl0yeW__button__sm",
  "chevron": "Button-module__cl0yeW__chevron",
  "content": "Button-module__cl0yeW__content",
  "dropdownMenu": "Button-module__cl0yeW__dropdownMenu",
  "dropdownOption": "Button-module__cl0yeW__dropdownOption",
  "spin": "Button-module__cl0yeW__spin",
  "spinner": "Button-module__cl0yeW__spinner",
  "splitButtonContainer": "Button-module__cl0yeW__splitButtonContainer",
  "splitButtonGroup": "Button-module__cl0yeW__splitButtonGroup",
  "splitButton__dropdown": "Button-module__cl0yeW__splitButton__dropdown",
  "splitButton__main": "Button-module__cl0yeW__splitButton__main",
});
